const storyImage1: string = require("../../images/hamburger1_hub.jpg");

export const aboutDatas = {
    title: "Panini",
    description:
    "Hub nasce dall'idea di unire il buon cibo al mondo del gaming. Prepariamo con cura ogni hamburger utilizzando " +
    "solo patty di carne 100% bovina piemontese e ingredienti di alta qualità. Scegli tu se averlo da 100g 200g o 300g " +
    "e accompagnalo con i nostri fritti. Se non hai voglia di carne rossa puoi optare per il pollo o per i nostri vegan " +
    `e veggy. Nel Menù sono presenti anche valide alternative per pasti leggeri e veloci. <br /> <br />` +
    "Nella nostra sala Lan dotata di 6 computer di fascia alta puoi vivere il gaming che è per noi sia uno stile " +
    "di vita che una passione. Il nostro obiettivo è farti divertire mentre giochi e socializzi allo stesso tempo.",
    image: storyImage1,
};
